export const state = () => ({
  configs: [],
  lastFetched: null,
  isFetching: false,
});

export const mutations = {
  SET_CONFIGS(state, configs) {
    state.configs = configs;
    state.lastFetched = new Date().getTime();
  },
  SET_FETCHING(state, status) {
    state.isFetching = status;
  },
};

export const getters = {
  getConfigs: (state) => state.configs,
  isStale: (state) => {
    if (!state.lastFetched) return true;
    // Check if data is older than 5 minutes
    const staleTime = 5 * 60 * 1000;
    return new Date().getTime() - state.lastFetched > staleTime;
  },
};

export const actions = {
  async fetchConfigs({ commit, state, getters }, force = false) {
    // Return cached data if available and not stale
    if (state.configs.length > 0 && !force && !getters.isStale) {
      return state.configs;
    }

    // Prevent multiple simultaneous requests
    if (state.isFetching) return state.configs;

    try {
      commit("SET_FETCHING", true);
      const { data } = await this.$axios.request({
        url: "/api/config/",
        method: "get",
        params: {
          active: 1,
        },
      });

      // Always update store on force refresh
      if (force || !state.configs.length) {
        commit("SET_CONFIGS", data?.results || []);
      }

      return data?.results;
    } catch (error) {
      // console.error("Error fetching configs:", error);
      return [];
    } finally {
      commit("SET_FETCHING", false);
    }
  },
};
